import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { FileUploadField, capitalizeFirstLetter } from '../Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepOne = ({ handleNext, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(prevState => ({
                ...prevState,
                shareCode: storedData?.rightToWorkShareCode,
                rightToWorkFile: storedData?.rightToWorkFile
            }));
        }
    }, []);

    const validateForm = (formData) => {
        const isValidate = isEmpty(formData?.rightToWorkFile) && isEmpty(formData?.shareCode);
        const errors = {
            rightToWorkFile: isValidate && 'Please either upload a document or provide a share code',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitRightToWork?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}&shareCode=${formData?.shareCode}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                    body: JSON.stringify(formData.rightToWorkFile?.Base64 || ""),
                });
                if (response.status === 200) {
                    handleNext({ rightToWorkShareCode: formData.shareCode });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    const handleFileUpload = (event) => {
        const newFile = event.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5 MB
        const name = event.target.name;
        if (newFile && newFile.size > maxSize) {
            alert("File size is too large. Maximum file size allowed is 5MB.");
            event.target.value = null; // clear the file input
            return;
        }

        const reader = new FileReader();

        reader.onload = function (event) {
            const base64String = btoa(
                new Uint8Array(event.target.result)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            const documentFilename = newFile.name;
            setFormData({
                ...formData,
                [name]: {
                    Base64: base64String,
                    DocumentFilename: documentFilename
                }
            });
        };

        reader.readAsArrayBuffer(newFile);
    }

    const handleRemoveFile = (name) => {
        setFormData({
            ...formData,
            [name]: null
        });
    };

    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >1. Right To Work</h2>
                <p style={{ marginTop: '-15px' }}>Please fill out all required fields</p>
            </Col>
            <span className='m-0'><h5>It is a legal requirement to conduct a “right to work” check on all prospective employees.  It is therefore mandatory that you provide one of the following document(s)</h5></span>
            <span className='m-0'><h5>1. Passport (Upload)</h5></span>
            <span className='m-0'><h5>2. Birth Certificate (issued in the UK, Channel Islands, the Isle of Man or Republic of Ireland) (Upload)</h5></span>
            <span className='m-0'><h5>3. Adoption Certificate (Upload)</h5></span>
            <span className='m-0'><h5>4. Current Immigration status document containing a photograph issued by the Home Office (Upload)</h5></span>
            <span className='m-0'><h5>5. Share code</h5></span>
            <span className='m-0'><h5>Upload Document:</h5></span>
            <span className='m-0'><h5>{formData.inductionId}</h5></span>

            <FileUploadField
                name="rightToWorkFile"
                documentFilename={formData.rightToWorkFile?.DocumentFilename}
                handleFileUpload={handleFileUpload}
                handleRemoveFile={handleRemoveFile}
            />

            <Col sm={12} md={6} className="my-1">
                <h5 className="title">Share code:</h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData.shareCode}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                shareCode: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.shareCode ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />

                </Form.Group>

            </Col>
            <Col sm={12} className="my-1" style={{ textAlign: 'left' }}>{errors.rightToWorkFile && <Form.Text className="text-danger"> <span className="star">*</span> {errors.rightToWorkFile} </Form.Text>}</Col>
            <Col sm={12} className="d-flex justify-content-end mt-3">
                <Button onClick={handleSubmit} variant="success" className="btn-lg btn-shadow btn-step">Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepOne;